/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export const ZIP_CODE_ERROR_MESSAGE = "Zip code must be in 12345 or 12345-6789 format";

export function validateZipCode(zipCode) {
  const normalizedZipCode = `${zipCode ?? ""}`.trim();

  if (!normalizedZipCode) {
    return true;
  }

  return /^\d{5}(-\d{4})?$/.test(normalizedZipCode);
}
